import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { useI18n } from "@/lib/i18n";
import { langPath } from "@/lib/routes";

export default function NotFound() {
  const { t, lang } = useI18n();
  return (
    <div className="mx-auto w-full max-w-6xl px-4 py-24 sm:px-6 lg:px-8">
      <Seo
        title={t("meta.notFound.title")}
        description={t("meta.notFound.description")}
        htmlLang={t("lang.htmlLang")}
      />
      <p className="font-mono text-[0.7rem] uppercase tracking-[0.2em] text-amber">
        {t("notFound.code")}
      </p>
      <h1 className="mt-4 max-w-[22ch] font-display text-[2.2rem] font-semibold leading-[1.1] tracking-[-0.02em] text-ink sm:text-[2.8rem]">
        {t("notFound.title")}
      </h1>
      <p className="mt-5 max-w-[58ch] text-[0.95rem] leading-7 text-muted-ink">
        {t("notFound.body")}
      </p>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link
          to={langPath(lang)}
          data-testid="notfound-home-link"
          className="rounded-xl bg-ink px-5 py-3 text-[0.86rem] font-semibold text-white transition-colors duration-200 hover:bg-ink2"
        >
          {t("notFound.cta")}
        </Link>
        <a
          href={`mailto:${t("footer.emailGeneral")}`}
          data-testid="notfound-mailto"
          className="rounded-xl border border-hairline bg-white px-5 py-3 text-[0.86rem] font-medium text-ink transition-colors duration-200 hover:bg-paper2"
        >
          {t("notFound.secondaryCta")}
        </a>
      </div>
    </div>
  );
}
